export default "__VITE_ASSET__CNF$E9Fk__"